import styleInject from './../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".LocalPaymentsRetryInitiator-module_retryAlert__y4OKS {\n  margin-bottom: 10px;\n}\n\n.LocalPaymentsRetryInitiator-module_retryMainAlert__vUVZQ {\n  margin-bottom: 15px;\n}";
var styles = {"retryAlert":"LocalPaymentsRetryInitiator-module_retryAlert__y4OKS","retryMainAlert":"LocalPaymentsRetryInitiator-module_retryMainAlert__vUVZQ"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=LocalPaymentsRetryInitiator.module.scss.js.map
